'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentBancontactClassicAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M73.501 49.1214C71.8968 49.1214 71.0747 48.2762 71.0747 46.5598V43.7509H70.1582V42.3204H71.0747V40.8768L72.9347 40.7862V42.3204H74.431V43.7509H72.9347V46.5338C72.9347 47.2883 73.2581 47.6393 73.8648 47.6393C74.1481 47.6393 74.404 47.6003 74.5789 47.5612L74.6739 49.0047C74.35 49.0823 73.9187 49.1214 73.501 49.1214ZM69.4114 42.5547L69.0611 43.9722C68.5488 43.7639 67.9961 43.6467 67.5378 43.6467C66.4459 43.6467 65.8527 44.3883 65.8527 45.6105C65.8527 46.9499 66.4729 47.6393 67.6323 47.6393C68.0771 47.6393 68.6163 47.5222 69.128 47.3008L69.4249 48.7444C68.9666 48.9657 68.2655 49.1214 67.4839 49.1214C65.2465 49.1214 63.9522 47.7825 63.9522 45.6625C63.9522 43.5561 65.233 42.1646 67.3759 42.1646C68.1445 42.1646 68.9126 42.3334 69.4114 42.5547ZM61.241 47.6523V46.2609C60.9312 46.1958 60.6079 46.1567 60.284 46.1567C59.6638 46.1567 59.1786 46.3911 59.1786 47.0019C59.1786 47.5482 59.5834 47.8341 60.2975 47.8341C60.7018 47.8341 61.0391 47.7565 61.241 47.6523ZM60.1091 49.1214C58.2621 49.1214 57.332 48.2502 57.332 47.08C57.332 45.7927 58.424 45.0382 60.0416 45.0252C60.4189 45.0252 60.9042 45.0772 61.241 45.1293V44.8174C61.241 44.0243 60.7693 43.6467 59.8662 43.6467C59.273 43.6467 58.6394 43.7378 58.0872 43.9592L57.7498 42.5547C58.3295 42.3204 59.2595 42.1646 60.0821 42.1646C62.0636 42.1646 63.0471 43.1791 63.0471 44.9345V48.5496C62.4949 48.8225 61.4569 49.1214 60.1091 49.1214ZM55.4139 49.1214C53.8097 49.1214 52.9876 48.2762 52.9876 46.5598V43.7509H52.0711V42.3204H52.9876V40.8768L54.8477 40.7862V42.3204H56.3439V43.7509H54.8477V46.5338C54.8477 47.2883 55.171 47.6393 55.7777 47.6393C56.0611 47.6393 56.3169 47.6003 56.4923 47.5612L56.5868 49.0047C56.2629 49.0823 55.8317 49.1214 55.4139 49.1214ZM45.0726 48.9657V42.7369C45.9217 42.3855 47.0811 42.1646 48.1191 42.1646C50.0865 42.1646 51.2189 43.101 51.2189 44.8304V48.9657H49.3589V44.9601C49.3589 44.0628 48.9276 43.6467 48.105 43.6467C47.6738 43.6467 47.2695 43.7248 46.9192 43.881V48.9657H45.0726ZM40.64 47.6393C41.597 47.6393 42.0957 46.8722 42.0957 45.6365C42.0957 44.4143 41.597 43.6467 40.64 43.6467C39.6965 43.6467 39.1707 44.4143 39.1707 45.6365C39.1707 46.8722 39.6965 47.6393 40.64 47.6393ZM40.64 49.1214C38.5641 49.1214 37.2702 47.7304 37.2702 45.6365C37.2702 43.5561 38.5641 42.1646 40.64 42.1646C42.7294 42.1646 43.9963 43.5561 43.9963 45.6365C43.9963 47.7304 42.7294 49.1214 40.64 49.1214ZM36.6215 42.5547L36.2712 43.9722C35.759 43.7639 35.2062 43.6467 34.748 43.6467C33.656 43.6467 33.0628 44.3883 33.0628 45.6105C33.0628 46.9499 33.683 47.6393 34.8424 47.6393C35.2872 47.6393 35.8264 47.5222 36.3387 47.3008L36.635 48.7444C36.1767 48.9657 35.4756 49.1214 34.694 49.1214C32.4567 49.1214 31.1628 47.7825 31.1628 45.6625C31.1628 43.5561 32.4432 42.1646 34.5861 42.1646C35.3547 42.1646 36.1228 42.3334 36.6215 42.5547ZM23.9749 48.9657V42.7369C24.824 42.3855 25.9829 42.1646 27.0208 42.1646C28.9888 42.1646 30.1212 43.101 30.1212 44.8304V48.9657H28.2612V44.9601C28.2612 44.0628 27.8299 43.6467 27.0073 43.6467C26.5761 43.6467 26.1718 43.7248 25.8215 43.881V48.9657H23.9749ZM20.8589 47.6523V46.2609C20.5491 46.1958 20.2253 46.1567 19.9019 46.1567C19.2818 46.1567 18.797 46.3911 18.797 47.0019C18.797 47.5482 19.2013 47.8341 19.9154 47.8341C20.3197 47.8341 20.6571 47.7565 20.8589 47.6523ZM19.727 49.1214C17.88 49.1214 16.95 48.2502 16.95 47.08C16.95 45.7927 18.0419 45.0382 19.6596 45.0252C20.0369 45.0252 20.5221 45.0772 20.8589 45.1293V44.8174C20.8589 44.0243 20.3872 43.6467 19.4842 43.6467C18.891 43.6467 18.2578 43.7378 17.7051 43.9592L17.3683 42.5547C17.9475 42.3204 18.8775 42.1646 19.7001 42.1646C21.6815 42.1646 22.665 43.1791 22.665 44.9345V48.5496C22.1128 48.8225 21.0748 49.1214 19.727 49.1214ZM11.2277 47.379H12.3871C13.519 47.379 14.1796 47.1061 14.1796 46.2479C14.1796 45.4027 13.6134 45.0512 12.5485 45.0512H11.2277V47.379ZM11.2277 43.6467H12.6159C13.465 43.6467 13.8293 43.2437 13.8293 42.5026C13.8293 41.7095 13.1687 41.4491 12.2791 41.4491H11.2277V43.6467ZM9.35413 48.9657V39.8629H12.2656C14.3815 39.8629 15.7428 40.63 15.7428 42.2167C15.7428 43.1135 15.3115 43.7378 14.7054 44.1019C15.5814 44.4919 16.0936 45.2465 16.0936 46.2739C16.0936 48.1075 14.7054 48.9657 12.5485 48.9657H9.35413Z",
          fill: "#1E3764"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.35413 22.6383V35.3017H22.3269C32.1649 35.3017 37.0838 28.9823 42.0028 22.6383H9.35413Z",
          fill: "url(#paint0_linear_647_4454)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M61.6912 9.9998C51.8542 10.0003 46.9456 16.3185 42.0179 22.6548L74.6563 22.6523L74.6747 9.9801L61.6912 9.9998Z",
          fill: "url(#paint1_linear_647_4454)"
        }
      ),
      /* @__PURE__ */ jsxs("defs", { children: [
        /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "paint0_linear_647_4454",
            x1: 15.9609,
            y1: 29.5652,
            x2: 39.6395,
            y2: 20.4492,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#005AB9" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#1E3764" })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "paint1_linear_647_4454",
            x1: 43.9891,
            y1: 23.7487,
            x2: 69.1624,
            y2: 14.8466,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#FBA900" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#FFD800" })
            ]
          }
        )
      ] })
    ]
  }
);
const VpPaymentBancontactClassicAsset = forwardRef(PaymentBancontactClassicAsset);

export { VpPaymentBancontactClassicAsset as default };
